import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="assignee-select"
// 担当者を選ぶだけで送信はしない（hidden に入れて、ボタンの表示を切り替える）
export default class extends Controller {
  static targets = [ 'input', 'label', 'indicator' ]

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    this.inputTarget.value = option.dataset.id || ''
    this.labelTarget.innerHTML = option.querySelector('template').innerHTML
    this.indicatorTargets.forEach((indicator) => {
      const selected = option.contains(indicator)
      indicator.classList.toggle('text-primary', selected)
      indicator.classList.toggle('text-light', !selected)
    })
  }
}
